<template>
  <v-dialog v-model="dialog.show" max-width="600" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="6">
              <v-text-field v-model="lead.nome" :rules="[rules.required]" label="Nome"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="lead.celular"
                v-mask="'(##)#####-####'"
                :rules="[rules.required]"
                label="Celular"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="lead.comentarios"
                :rules="[rules.required]"
                label="Comentarios"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <DateMenu label="Data Proximo Contato" @onChanged="lead.dataProxContato = $event" />
            </v-col>
            <v-col cols="6">
              <SelectFormaPagamento @onChanged="lead.formaDePagamento = $event" />
            </v-col>
            <v-col cols="6">
              <v-text-field
                label="Veiculo"
                @click="$refs.dialogSelectVeiculos.show()"
                v-model="lead.nomeVeiculo"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="blue darken-1"
          small
          dark
          rounded
          depressed
          @click="save()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
    <DialogSelectVeiculos ref="dialogSelectVeiculos" @selected="setSelectedVeiculo($event)" />
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import rules from "@/utils/rules";
import { Vendedor } from "@/services/lead";

export default {
  name: "DialogFormCreate",

  components: {
    DateMenu: () => import("@/components/datepicker/DateMenu"),
    DialogSelectVeiculos: () => import("../../components/DialogSelectVeiculos"),
    SelectFormaPagamento: () => import("../../components/SelectFormaPagamento")
  },

  data() {
    return {
      lead: {
        celular: "",
        comentarios: "",
        dataCriacao: new Date(),
        dataProxContato: new Date(),
        donoDoLead: "",
        empresa: "",
        formaDePagamento: "",
        idVeiculo: "",
        location: {
          latitude: 0,
          longitude: 0
        },
        nome: "",
        nomeVeiculo: "",
        origem: "flyVendas",
        status: "Pendente",
        termometro: "SuperQuente",
        tipoOrigem: "Presencial"
      },
      serviceLeadsVendedor: new Vendedor(),
      dialog: {
        show: false,
        title: "Criar Lead"
      },
      rules
    };
  },

  computed: {
    ...mapGetters("auth", ["getUser"])
  },

  methods: {
    show() {
      this.lead.donoDoLead = this.getUser.cpf;
      this.lead.empresa = this.getUser.empresaPrincipal;
      this.getGeoLocation();
      this.dialog.show = true;
    },

    getGeoLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.lead.location.latitude = position.coords.latitude;
          this.lead.location.longitude = position.coords.longitude;
        });
      } else {
        this.$toast.error("Seu navegador não suporta Geolocalização");
      }
    },

    setSelectedVeiculo(veiculo) {
      this.lead.nomeVeiculo = veiculo.descricao;
      this.lead.idVeiculo = veiculo.id;
    },

    async save() {
      if (this.$refs.form.validate()) {
        try {
          await this.serviceLeadsVendedor.create({ ...this.lead });
          this.close();
          return Promise.resolve();
        } catch (error) {
          this.$toast.error("Erro ao criar Lead");
          return Promise.reject(error);
        }
      }
    },

    close() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.dialog.show = false;
    }
  }
};
</script>
